import React from 'react';
import LookupItemService from '../Services/LookupItemService';


class LookupText extends React.Component 
{

    static defaultProps =
        {
            lookupId: 0,
            value: 0,
            withValue: false,
        };

    constructor (props) 
    {
        super(props);
        this.state =
        {
            text: ""
        };
    }

    componentDidMount () 
    {
        this.GetLookup();
    }

    GetLookup () 
    {
        LookupItemService.GetLookupItemByLookupIdAndLookupValue(this.props.lookupId, this.props.value)
            .then(result => this.setState({ text: result.text + (this.props.withValue ? " (" + result.value + ")" : "") }))
            .catch(error => this.setState({ text: "" }));
    }

    componentDidUpdate (prevProps) 
    {
        if (this.props.lookupId !== prevProps.lookupId)
            this.GetLookup();
    }

    render () 
    {
        return this.state.text;
    }
}


export default LookupText;
